import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.replace = function replace (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: () => import('./views/index.vue'),
      meta: {
        title: '首页',
		keepAlive: true 
      },

    },
    {
      path: '/shopDetail',
      name: 'shopDetail',
      component: () => import('./views/shopDetail/shopDetail.vue'), // 商品详情
      meta: {
        title: '商品详情'
      }
    },
    {
      path: '/shopDetail22',
      name: 'shopDetail22',
      component: () => import('./views/shopDetail/shopDetail.vue'), // 商品详情
      meta: {
        title: '商品详情'
      }
    },
    {
      path: '/video',
      name: 'video',
      component: () => import('./views/shopDetail/video.vue'), // 商品详情
      meta: {
        title: '商品介绍'
      }
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('./views/shopDetail/account.vue'), // 结算
      meta: {
        title: '结算'
      }
    },
    {
      path: '/success',
      name: 'success',
      component: () => import('./views/shopDetail/success.vue'), // 结算
      meta: {
        title: '结算'
      }
    },
    {
      path: '/record',
      name: 'record',
      component: () => import('./views/jifenRecord/record.vue'), //积分记录
      meta: {
        title: '积分记录'
      }
    },
    {
      path: '/personalCenter',
      name: 'personalCenter',
      component: () => import('./views/personalCenter/personalCenter.vue'), //个人中心
      meta: {
        title: '我的'
      }
    },
    {
      path: '/shareList',
      name: 'shareList',
      component: () => import('./views/personalCenter/shareList.vue'), //个人中心
      meta: {
        title: '我的'
      }
    },
    {
      path: '/setUp',
      name: 'setUp',
      component: () => import('./views/personalCenter/setUp.vue'), //设置
      meta: {
        title: '设置'
      }
    },
    {
      path: '/bindMobile',
      name: 'bindMobile',
      component: () => import('./views/bindMobile/bindMobile.vue'), //绑定手机号
      meta: {
        title: '手机号码'
      }
    },
    {
      path: '/editMobile',
      name: 'editMobile',
      component: () => import('./views/bindMobile/editMobile.vue'), //更换手机号
      meta: {
        title: '修改手机号'
      }
    },
    {
      path: '/changeMobile',
      name: 'changeMobile',
      component: () => import('./views/bindMobile/changeMobile.vue'), //更换手机号
      meta: {
        title: '更换手机号'
      }
    },
    {
      path: '/orderDetails',
      name: 'orderDetails',
      component: () => import('./views/myOrder/orderDetails.vue'), //订单详情
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/orderSchedule',
      name: 'orderSchedule',
      component: () => import('./views/myOrder/orderSchedule.vue'), //进度详情
      meta: {
        title: '进度详情'
      }
    },
    {
      path: '/order',
      name: 'order',
      component: () => import('./views/myOrder/order.vue'), //订单列表
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/orderSearch',
      name: 'orderSearch',
      component: () => import('./views/myOrder/orderSearch.vue'), //订单列表
      meta: {}
    },
    {
      path: '/cart',
      name: 'Cartpage',
      component: () => import('./views/cart.vue'), //订单详情
      meta: {
        title: '购物车'
      }
    },
    {
      path: '/orderConfirm',
      name: 'orderConfirm',
      component: () => import('./views/payment/orderConfirm.vue'), //订单详情
      meta: {
        title: '确认订单'
      }
    },
    {
      path: '/addressAddto',
      name: 'addressAddto',

      component: () => import('./views/address/addto.vue'), //添加地址
      meta: {
        title: '添加地址'
      }
    },
    {
      path: '/addressList',
      name: 'addressList',

      component: () => import('./views/address/list.vue'), //地址列表
      meta: {
        title: '我的地址'
      }
    },
    {
      path: '/addressModify',
      name: 'addressModify',

      component: () => import('./views/address/modify.vue'), //地址列表
      meta: {
        title: '修改地址'
      }
    },
    {
      path: '/search',
      name: 'search',

      component: () => import('./views/search/search.vue'), //搜索
      meta: {
        title: '搜索',
        keepAlive: true 
      }
    },
    {
      path: '/classify',
      name: 'classify',
      component: () => import('./views/classify/classify.vue'), //分类
      meta: {
        title: '分类',
		keepAlive: true 
      }
    },
    {
      path: '/collecExchange',
      name: 'collecExchange',
      component: () => import('./views/collecExchange/collecExchange.vue'), //我能兑换
      meta: {
        title: '我的收藏',
        keepAlive: true 
      }
    },
	{
	  path: '/newCollec',
	  name: 'newCollec',
	
	  component: () => import('./views/collecExchange/newCollec.vue'), //我能兑换
	  meta: {
	    title: '我能兑换',
	    keepAlive: true 
	  }
	},
    {
      path: '/login',
      name: 'login',

      component: () => import('./views/login.vue'), //登录
      meta: {
        title: '登录'
      }
    },
    {
      path: '/bindphone',
      name: 'bindphone',

      component: () => import('./views/bindphone.vue'), //登录
      meta: {
        title: '绑定手机号'
      }
    },
    {
      path: '/wuliu_info',
      name: 'wuliu_info',
      component: () => import('./views/myOrder/wuliu_info.vue'), //订单跟踪
      meta: {
        title: '订单跟踪'
      }
    },{
      path: '/wuliuList',
      name: 'wuliuList',
      component: () => import('./views/myOrder/wuliuList.vue'), //物流列表
      meta: {
        title: '订单跟踪'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/loginCon/register.vue'), //注册账号
      meta: {
        title: '注册账号'
      }
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: () => import('./views/loginCon/resetPassword.vue'), //重置密码
      meta: {
        title: '重置密码'
      }
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: () => import('./views/personalCenter/mobile.vue'), //手机绑定
      meta: {
        title: '手机绑定'
      }
    },
    {
      path: '/appletsIndex',
      name: 'appletsIndex',
      component: () => import('./views/applets/appletsIndex.vue'), //手机绑定
      meta: {
        title: '积分商城'
      }
    },

    {
      path: '/settleAccountRecord',
      name: 'settleAccountRecord',
      component: () => import('./views/personalCenter/settleAccountRecord.vue'), //手机绑定
      meta: {
        title: '结账记录'
      }
    },

    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: () => import('./views/protocol/userAgreement.vue'), //积分用户协议
      meta: {
        title: '用户协议'
      }
    },
    {
      path: '/serviceAgreement',
      name: 'serviceAgreement',
      component: () => import('./views/protocol/serviceAgreement.vue'), //推广服务协议
      meta: {
        title: '推广服务协议'
      }
    },
    {
      path: '/userPrivacy',
      name: 'userPrivacy',
      component: () => import('./views/protocol/userPrivacy.vue'), //推广服务协议
      meta: {
        title: '积分商城用户隐私保护政策'
      }
    },
	{
	  path: '/Ranking',
	  name: 'Ranking',
	  component: () => import('./views/Ranking/list.vue'), //推广服务协议
	  meta: {
	    title: '排行榜',
		keepAlive: true 
	  }
	},
	{
	  path: '/SnapshotDetails',
	  name: 'SnapshotDetails',
	  component: () => import('./views/shopDetail/SnapshotDetails.vue'), // 商品详情
	  meta: {
	    title: '交易快照'
	  }
	},
	
  ]
})
